import { Typography, getTheme, styled } from '~/modules';

const spacingSm = getTheme('spacing.sm');

export const CreditValueLabel = styled(Typography)`
  font-weight: 400;
`;

export const CreditValue = styled(Typography).attrs({
  variant: 'max',
})`
  font-weight: 600;
`;

export const UpperSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacingSm}px;
`;
